export const formatCurrency = (amount?: string | null): string => {
  return Number(amount || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

// plc-app's formatMoney (src/lib/helpers/format-money.ts): whole amounts drop the cents unless alwaysDecimal,
// which is how it writes credit amounts like "$5 used"
export const formatMoney = (amount?: string | number | null, { alwaysDecimal = false }: { alwaysDecimal?: boolean } = {}): string => {
  const value = Number(amount || 0)
  const safeValue = Number.isNaN(value) || value < 0.01 ? 0 : value
  const hasCents = !Number.isInteger(safeValue)
  return safeValue.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: hasCents || alwaysDecimal ? 2 : 0,
    maximumFractionDigits: 2,
  })
}
